import { store } from '../../../../../resources/frontend/js/store';

export default (question) => {
    // This happens with the last question, it redirects to the next step
    if (question === null) return 'next_step';

    return store.getters['page/getStepFromString'](store.state.quiz.questionsData.find(questionData => {
        if(typeof question === 'number') return store.state.quiz.questionsData[question - 1] === questionData;

        return questionData._info.uuid === question;
    }).step);
};
